import { styled } from "@mui/material";

export const CalendarContainer = styled('div')`
display:flex;
flex-direction:column;
justify-content: space-between;
    width: fit-content;
    padding: 10px 0 0 0;
    height: 75vh;
    border: 1px solid #E4E4E3;
  /* font-family: 'Arial', sans-serif; */
`;

export const CalendarHeader = styled('div')`
  width: fit-content;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  background-color: #F7F7F7;
  font-family: 'Poppins', sans-serif;
  margin-left: 20px;
`;

export const CalendarTable = styled('table')`
  width: fit-content;
  border-collapse: collapse;
`;

export const CalendarTableHead = styled('thead')`
  /* width: fit-content; */
  /* border: 1px solid red; */
  color: #4392E0;
  background-color: #FFFFFF;
`;

export const CalendarTableRow = styled('tr')`
  /* width: fit-content; */
  display: flex;
`;


export const CalendarTableHeader = styled('th')`
/* border: 1px solid red; */
  border: 1px solid #E4E4E3;
  background-color: #FFFFFF;
  display: flex;
  padding-right: 10px;
  align-items: center;
  justify-content: flex-end;
  height: 40px;
  width: 60px;
  font-size: 14px;
  font-weight: 500;
  `;

export const CalendarTableBody = styled('tbody')`
  width: fit-content;
  /* border: 1px solid #E4E4E3; */
`;

export const CalendarTableCell = styled('td')`
  border: 1px solid #E4E4E3;
  background-color: #F7F7F7;
  padding: 5px;
  font-size: 14px;
  font-weight: 500;
`;

export const MainItem = styled('div')`
/* border: 1px solid red; */
display: flex;
align-items: flex-start;
justify-content: flex-end;
padding: 5px;
height: 100%;
color: #454545;
cursor: pointer;
background-color: #F7F7F7;
height: 48.5px;
width: 48.5px;
border-radius: 4px;

&.selected {
  background-color: #4A79E7;
  color: #FFFFFF;
}

&.weekend {
  background-color: #E4E4E4;
}

&.weekend.selected {
  background-color: #f15954;
  color: #fff;
}

&.empty {
  cursor: default;
  background-color: #efefef;
}
`;

export const CalendarFooter = styled('div')`
  border-top: 1px solid #E4E4E3;
  height: 58px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
`;